import { render, staticRenderFns } from "./ModalSupplierProfile.vue?vue&type=template&id=3534d5c0&scoped=true&"
import script from "./ModalSupplierProfile.vue?vue&type=script&lang=js&"
export * from "./ModalSupplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupplierProfile.vue?vue&type=style&index=0&id=3534d5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534d5c0",
  null
  
)

export default component.exports